import { Grid } from "@mui/material";
import React from "react";
import PosHeader from "./home/header";
import PosTabel from "./home/table";

const Pos = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PosHeader />
      </Grid>
      <Grid item xs={12}>
        <PosTabel />
      </Grid>
    </Grid>
  );
};

export default Pos;
